var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dilu-page"},[_vm._v(" [能源监测] 开发中... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }